module.exports = __webpack_public_path__ + "img/map-img-skeleton-smaller.2725082b.webp";